module.exports = __webpack_public_path__ + "static/media/qr-code-emec.82bcb59f.png";